import React from 'react';
import './DayNav.css';
import PropTypes from 'prop-types';
import { COLORS_AVISOS as colors } from '../../utils/globals';

const DayNavItem = props => {
    const {
        currentDay,
        numberOfDay,
        color,
        dayNavigation,
        label,
        maxPerill,
    } = props;

    return (
        <li>
            <a
                style={currentDay === numberOfDay ? { color: color } : null}
                onClick={() => dayNavigation(numberOfDay)}
                className={
                    currentDay === numberOfDay
                        ? `day-nav__day day-nav__day-${numberOfDay} day-nav__day-active`
                        : `day-nav__day day-nav__day-${numberOfDay}`
                }
            >
                {label}
            </a>
            {(maxPerill || maxPerill === 0) && (
                <span
                    className="day-marker"
                    style={{
                        backgroundColor:
                            maxPerill === 0
                                ? colors.sensePerill
                                : maxPerill === 1
                                    ? colors.perillModerat
                                    : maxPerill === 2
                                        ? colors.perillAlt
                                        : maxPerill === 3
                                            ? colors.perillMoltAlt
                                            : null,
                    }}
                />
            )}
        </li>
    );
};

DayNavItem.propTypes = {
    numberOfDay: PropTypes.number,
    currentDay: PropTypes.number,
    color: PropTypes.string,
    dayNavigation: PropTypes.func,
    label: PropTypes.string,
    maxPerill: PropTypes.number,
};

export default DayNavItem;



// WEBPACK FOOTER //
// ./src/partials/DayNav/DayNavItem.js